(() => {
  const card = document.querySelector('[data-kales-promo-peek]');
  if (!card || card.dataset.ready) return;
  card.dataset.ready = 'true';
  const key = 'kales-benefits-dismissed-v1';
  let dismissed = false;
  try { dismissed = sessionStorage.getItem(key) === '1'; } catch {}
  if (dismissed || location.pathname.includes('/pages/beneficios-kales')) return;
  const timer = setTimeout(() => { card.hidden = false; }, 6500);
  card.querySelector('[data-promo-dismiss]')?.addEventListener('click', () => {
    clearTimeout(timer);
    card.hidden = true;
    try { sessionStorage.setItem(key, '1'); } catch {}
  });
})();
